/**
 * Pastilak — Marquee auto-duplicator
 * -----------------------------------
 * The CSS loop (translateX(-50%) on a track containing N copies of the
 * same set) only looks seamless if the *total* track width is at least
 * double the viewport width. Short text (e.g. a handful of short pills
 * like "TASTES GOOD") combined with a wide screen can mean a fixed
 * number of copies isn't enough — the track runs out of content before
 * the animation reaches the wrap point, showing a blank gap that looks
 * like the marquee "just stops."
 *
 * This clones the first set into the track until the track is at least
 * 2x the current viewport width, guaranteeing a seamless loop at any
 * screen size or content length. Re-runs on resize (debounced).
 */
(function () {
  'use strict';

  function fillTrack(track) {
    const baseSet = track.querySelector('[data-marquee-set]');
    if (!baseSet) return;

    // Remove any previously added clones before recalculating
      track.querySelectorAll('[data-marquee-set-clone]').forEach((el) => el.remove());

    const setWidth = baseSet.getBoundingClientRect().width;
    const targetWidth = window.innerWidth * 2;
    let currentWidth = setWidth;

    // Safety cap so a broken/empty set can't loop forever
    let guard = 0;
    while (currentWidth < targetWidth && guard < 50) {
      const clone = baseSet.cloneNode(true);
      clone.removeAttribute('data-marquee-set');
      clone.setAttribute('data-marquee-set-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
      currentWidth += setWidth;
      guard++;
    }

    // The animation shifts by exactly one set-width, not a fixed 50% —
    // that stays correct no matter how many clones were needed.
    track.style.setProperty('--marquee-set-width', `${setWidth}px`);
  }

  function init() {
    const tracks = document.querySelectorAll('[data-marquee-track]');
    tracks.forEach(fillTrack);

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => tracks.forEach(fillTrack), 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();